import {
  BarChart3, ChevronRight, Coins, CreditCard, FileText, Package,
  Rocket, Settings2, ShoppingBag, Tag, Truck, Users, Wallet, Boxes,
} from 'lucide-react';
import type { HelpArticle, HelpIconName } from '../types';
import { MediaBadge } from './MediaPlayer';

const ICONS: Record<HelpIconName, typeof FileText> = {
  'primeros-pasos': Rocket,
  factura: FileText,
  caja: Wallet,
  productos: Package,
  clientes: Users,
  cobranzas: Coins,
  inventario: Boxes,
  'guias-remision': Truck,
  compras: ShoppingBag,
  'punto-venta': CreditCard,
  precios: Tag,
  indicadores: BarChart3,
  configuracion: Settings2,
};

interface ArticleRowProps {
  article: HelpArticle;
  /** Se muestra la categoría en la segunda línea cuando la lista está en modo "plano" (búsqueda activa). */
  showCategory: boolean;
  onOpen: (id: string) => void;
}

export function ArticleRow({ article, showCategory, onOpen }: ArticleRowProps) {
  const Icon = ICONS[article.icon];

  return (
    <button
      type="button"
      onClick={() => onOpen(article.id)}
      className="flex w-full items-center gap-2.5 rounded-md px-2 py-3 text-left transition-colors hover:bg-surface-hover"
    >
      <span className="relative flex h-[34px] w-[34px] flex-shrink-0 items-center justify-center rounded-md bg-surface-2 text-tertiary">
        <Icon className="h-4 w-4" />
        <MediaBadge media={article.media} />
      </span>

      <span className="min-w-0 flex-1">
        <p className="text-ui-sm font-semibold text-primary">{article.title}</p>
        <p className="truncate text-caption text-muted">
          {showCategory && <span className="text-subtle">{article.category} · </span>}
          {article.snippet}
        </p>
      </span>

      <ChevronRight className="h-4 w-4 flex-shrink-0 text-subtle" />
    </button>
  );
}
